import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

const HEAD_FONT = { fontFamily: '"IBM Plex Sans", Inter, sans-serif' };
const BODY_FONT = { fontFamily: 'Inter, "IBM Plex Sans", sans-serif' };

export default function Terms() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFAFA] text-black" style={BODY_FONT}>
      <nav className="border-b border-black/10 bg-white/70 backdrop-blur-xl">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <button
            data-testid="terms-back-btn"
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-sm text-black/70 hover:text-black"
          >
            <ArrowLeft size={14} weight="bold" /> Home
          </button>
          <span className="text-sm font-black tracking-tight" style={HEAD_FONT}>Founderboard</span>
        </div>
      </nav>

      <article className="max-w-3xl mx-auto px-6 py-16 lg:py-24" data-testid="terms-page">
        <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-black/60 mb-4">Legal</div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1] mb-6" style={HEAD_FONT}>
          Terms of Service
        </h1>
        <p className="text-sm text-black/50 mb-12">Last updated: February 2026</p>

        <div className="space-y-8 text-base text-black/75 leading-relaxed">
          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>1. Acceptance</h2>
            <p>
              By creating an account on Founderboard you agree to these terms. If you don't agree, please don't use the service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>2. Eligibility</h2>
            <p>
              Founderboard is intended for venture capital funds, incubators, accelerators, angel groups, and the startups they back. You must be at least 18 years old and authorised to act on behalf of your organisation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>3. Accounts & seats</h2>
            <p>
              Each team member needs their own login. Owners may invite Admin and Member seats. Sharing logins is prohibited. Seat pricing is volume-tiered and billed monthly. Startups receive 6 months free; the trial converts to ₹499/seat/month thereafter.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>4. Acceptable use</h2>
            <p>
              You agree not to scrape data, attempt unauthorised access, upload malicious content, impersonate other users, or use the service for activity that violates Indian law (including SEBI, FEMA, RBI regulations as applicable).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>5. Your content</h2>
            <p>
              You retain ownership of everything you upload — pitch decks, monthly updates, applications, metrics. You grant Founderboard a limited licence to store and display this content to the users you authorise (your team, your VCs, your applicants).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>6. AI features</h2>
            <p>
              AI responses are advisory only — not legal, financial, or investment advice. Verify before acting. We are not liable for decisions made based on AI output.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>7. Cancellation & refunds</h2>
            <p>
              You can cancel at any time from the Billing tab. Pro-rata refunds are not provided. Free trials end without charge if you cancel before they expire.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>8. Liability</h2>
            <p>
              Founderboard is provided "as is" without warranty. To the maximum extent permitted by law, our total liability is capped at the amount you paid us in the prior 12 months.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>9. Governing law</h2>
            <p>
              These terms are governed by the laws of India. Disputes are subject to the exclusive jurisdiction of the courts in Bengaluru, Karnataka.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black tracking-tight text-black mb-3" style={HEAD_FONT}>10. Contact</h2>
            <p>
              <a href="mailto:sid@founderboard.io" className="underline hover:text-black">sid@founderboard.io</a>
            </p>
          </section>
        </div>
      </article>
    </div>
  );
}
